<template>
  <div class="text-right font-28">
    <span v-if="value || text" :class="[`font-${options.fontSize}`]">
      {{ text ? text : getShowFields(value) }}
    </span>
    <span v-else class="cor-CC">
      {{ placeholder }}
    </span>
    <van-icon v-if="isShowIcon" name="arrow" color="#8c8c8c"/>
  </div>
</template>
<script>
export default {
  name: "index",
  props: {
    text: {
    },
    placeholder: {
      type: String
    },
    value: {},
    isShowIcon: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    options: {
      type: Object,
      default: () => {
        return {}
      },
      // validator: (obj) => {
      //   /*
      //    * @data 要匹配的原始数据，要求是个数组
      //    * @showFields 显示的汉字
      //    * @valueKey 匹配依据的字段
      //    * @childrenKey 可以不传  如果是树状结构数据需要传childrenKey 代表子集的key
      //    */
      //   return 'data' in obj && 'showFields' in obj && 'valueKey' in obj;
      // }
    },
  },
  methods: {
    getShowFields(value) {
      if (this.options.childrenKey) {
        // 如果树状结构数据 则需要递归寻找
        const find = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i][this.options.valueKey] === value) {
              return data[i][this.options.showFields]; // 匹配到了，返回结果
            } else if (data[i][this.options.childrenKey]) {
              // 递归调用，并处理返回值
              const result = find(data[i][this.options.childrenKey], value);
              if (result) {
                return result; // 如果在子项中找到匹配的值，返回它
              }
            }
          }
          return null; // 如果没有找到匹配的项，返回null
        }
        return find(this.options.data)
      } else {
        if (!this.options.data) return; // 判空
        const item = this.options.data.find((item) => {
          return item[this.options.valueKey] == value
        })
        if (!item) return;// 判空

        return item[this.options.showFields]
      }

    }
  },
}
</script>
